import Record from '@/base/model/record';

class User extends Record {

    static moduleName = 'user';

}

export default User;
